import React from 'react';

import ConvelioLogoBlack from '../assets/images/svg/convelio-black.svg';
import ConvelioLogoWhite from '../assets/images/svg/convelio-white.svg';

function Svg({ svg }) {
  switch (svg) {
    case 'convelio-logo-black':
      return <ConvelioLogoBlack />;
    case 'convelio-logo-white':
      return <ConvelioLogoWhite />;
    default:
      return <></>;
  }
}

export default Svg;
